import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Shell from './shell'
import LandingPage from './pages/landing-page'
import LoginPage from './pages/login-page'
import WelcomePage from './pages/welcome-page'
import ForgotPasswordPage from './pages/forgot-password-page'
import ConfirmAccountPage from './pages/confirm-account-page'
import ConfirmAccountSuccessPage from './pages/confirm-account-success-page'
import LoggedOutPage from './pages/logged-out-page'

function Routes() {
  return (
    <Router>
      <Shell>
        <Switch>
          <Route exact path="/" component={LandingPage} />
          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/welcome" component={WelcomePage} />
          <Route exact path="/forgot-password" component={ForgotPasswordPage} />
          <Route exact path="/confirm-account" component={ConfirmAccountPage} />
          <Route exact path="/confirm-account/success" component={ConfirmAccountSuccessPage} />
          <Route exact path="/logged-out" component={LoggedOutPage} />
          <Route path="*" render={() => <Box my={4} textAlign="center">Page Not Found</Box>} />
        </Switch>
      </Shell>
    </Router>
  )
}

export default Routes
